import { Button } from 'blaze-ui/Button'
import Styles from './CaptionTab.module.scss'
import { useState } from 'react'
import { Input } from 'almanac-ui/TextInputField/Input'
import useResponsiveDesign from 'hooks/useResponsiveDesign'

type Props = {
  insertCaption: (caption: string) => void
}

export const CaptionWriteYourOwn = (props: Props) => {
  const { insertCaption } = props
  const [caption, setCaption] = useState('')
  const [inserting, setInserting] = useState(false)
  const { isMobile } = useResponsiveDesign()

  const handleInsert = async () => {
    if (!inserting) {
      setInserting(true)
      await insertCaption(caption)
      setInserting(false)
    }
  }

  return (
    <div className={Styles.form}>
      <div className={Styles.field}>
        <span>
          Post Caption <span className={Styles.required}>*</span>
        </span>
        <Input
          className={Styles.textArea}
          aria-label="Post caption"
          name="caption"
          value={caption}
          onChange={(e) => setCaption(e.target.value)}
          placeholder="Write your post caption here..."
          isTextarea
          rows={isMobile ? 10 : 3}
          size={isMobile ? 'md' : 'sm'}
        />
      </div>

      <div className={Styles.footer}>
        <Button
          isDisabled={inserting || caption.trim().length === 0}
          size={isMobile ? 'lg' : 'md'}
          onPress={handleInsert}
        >
          {inserting ? 'Inserting Caption...' : 'Insert Caption'}
        </Button>
      </div>
    </div>
  )
}
